// extracted by mini-css-extract-plugin
module.exports = {"hero-banner__image":"HeroBanner_hero-banner__image__38xsD"};